import { setLimit } from "../../../ducks/catalog/catalog";
import { getLimit } from "../../../ducks/catalog/selectors";
import { useFilter } from "./useFilter";

export const useLimit = () => {
  return useFilter(getLimit, setLimit);
};
